(() => {
  const SELECTOR = '[data-final-sale-orbit]';

  const normalizeOffset = (offset, length) => {
    let normalized = offset;
    const half = Math.floor(length / 2);

    while (normalized > half) normalized -= length;
    while (normalized < -half) normalized += length;

    return normalized;
  };

  const slotForOffset = (offset) => {
    if (offset === 0) return 'active';
    if (offset === -1) return 'prev';
    if (offset === 1) return 'next';
    if (offset === -2) return 'far-prev';
    if (offset === 2) return 'far-next';
    return 'hidden';
  };

  const initOrbit = (orbit) => {
    if (orbit.dataset.orbitReady === 'true') return;

    const items = Array.from(orbit.querySelectorAll('[data-final-sale-orbit-item]'));
    if (!items.length) return;

    orbit.dataset.orbitReady = 'true';

    const interval = Number.parseInt(orbit.dataset.interval || '2000', 10);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let activeIndex = 0;
    let timer = null;
    let paused = false;

    const paint = () => {
      items.forEach((item, index) => {
        const offset = normalizeOffset(index - activeIndex, items.length);
        const slot = slotForOffset(offset);
        item.dataset.orbitSlot = slot;
        item.setAttribute('aria-hidden', slot === 'hidden' ? 'true' : 'false');
        item.tabIndex = slot === 'active' ? 0 : -1;
      });
    };

    const next = () => {
      activeIndex = (activeIndex + 1) % items.length;
      paint();
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      stop();
      if (reduceMotion || paused || items.length < 2) return;
      timer = window.setInterval(next, Math.max(interval, 1200));
    };

    const setPaused = (value) => {
      paused = value;
      if (paused) stop();
      else start();
    };

    orbit.addEventListener('mouseenter', () => setPaused(true));
    orbit.addEventListener('mouseleave', () => setPaused(false));
    orbit.addEventListener('focusin', () => setPaused(true));
    orbit.addEventListener('focusout', (event) => {
      if (!orbit.contains(event.relatedTarget)) setPaused(false);
    });

    orbit.addEventListener('click', (event) => {
      const item = event.target.closest('[data-final-sale-orbit-item]');
      if (!item || item.dataset.orbitSlot === 'active') return;

      event.preventDefault();
      const clickedIndex = items.indexOf(item);
      if (clickedIndex === -1) return;
      activeIndex = clickedIndex;
      paint();
      start();
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else start();
    });

    paint();
    start();
  };

  const initAll = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach(initOrbit);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
